import React from "react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Text, Button } from "@core/index";

interface ContentSectionProps {
  title: string;
  onAddNew: () => void;
  addButtonLabel: string;
  isEmpty: boolean;
  emptyStateMessage: string;
  children: React.ReactNode;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const ContentSection: React.FC<ContentSectionProps> = ({
  title,
  onAddNew,
  addButtonLabel,
  isEmpty,
  emptyStateMessage,
  children,
  containerRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 min-h-0">
      <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg rounded-lg p-4 shadow-lg border border-gray-200/50 dark:border-gray-700/50 h-full flex flex-col">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0 mb-4">
          <Text variant={"h2"}>{title}</Text>
          <Button
            onClick={onAddNew}
            size="md"
            rounded="lg"
            bgColor="bg-rose-500 hover:bg-rose-600"
            textColor="text-white"
            className="w-full sm:w-auto"
          >
            <Plus size={16} className="mr-2" />
            {addButtonLabel}
          </Button>
        </div>

        <div
          ref={containerRef}
          className="flex-1 overflow-y-auto custom-scrollbar space-y-4 pr-2"
        >
          {isEmpty ? (
            <div className="flex flex-col items-center justify-center h-full text-center py-8 text-gray-500 dark:text-gray-400">
              <div className="mb-4">
                <Plus size={40} className="opacity-20" />
              </div>
              {emptyStateMessage}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};
